import client from '@/shared/apis/client'

/**
 * メモ項目を更新する
 *
 * @param yakurekiId - 薬歴ID
 * @param memoItems - メモ項目のリスト
 */
export const updateMemoItems = async (
  yakurekiId: string,
  memoItems: string[]
): Promise<{ memo_items: string[] }> => {
  const response = await client.patch<{ memo_items: string[] }>(
    `/api/yakureki/${yakurekiId}/update-memo/`,
    { memo_items: memoItems }
  )
  return response.data
}
